import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
  Spinner,
} from '@apollo/orbit';
import React from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const SendTestNotificationModal = ({
  loadingTestNotification,
  setSendTestModalVisible,
  channel,
}: {
  loadingTestNotification: Boolean;
  setSendTestModalVisible: (visible: boolean) => void;
  channel: GraphQLTypes.ChannelCardChannelFragment;
}) => {
  return (
    <Modal isOpen={true} onClose={() => setSendTestModalVisible(false)}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>
            {loadingTestNotification
              ? 'Sending test notification'
              : 'Test notification sent'}
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          {loadingTestNotification ? (
            <div className="flex items-center justify-center">
              <Spinner />
            </div>
          ) : (
            <div>
              A testing notification was sent to notification channel{' '}
              <em>{channel.name}</em>.
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            {!loadingTestNotification && (
              <Button
                variant="secondary"
                isDisabled={loadingTestNotification}
                onClick={() => setSendTestModalVisible(false)}
              >
                Ok
              </Button>
            )}
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
